import { ModuleRoute } from 'module-routes';

export enum AutenticationPath {
  Login = '',
  Home = 'home',
  BranchOfficeList = 'branch-office-list',
}

export const AutenticationModuleRoutes = new Map<AutenticationPath, string>([
  [AutenticationPath.Login, `${ModuleRoute.Login}/${AutenticationPath.Login}`],
  [AutenticationPath.Home, `${ModuleRoute.Dashboard}/`],
  [AutenticationPath.BranchOfficeList, `${ModuleRoute.Login}/${AutenticationPath.BranchOfficeList}`],
]);
